export default {
  VOUCHER: 'voucher',
  //EMAIL: 'email',
  ELIGIBILITY_LIST: 'eligibility_list',
  //PARTICIPATION_ID: 'participation_id',
  SOLERA: 'solera',
  PERSONIFY_HEALTH_SSO: 'virginpulse_sso',
  UHCHUB: 'uhchub',
  UHCSTORE: 'uhcstore',
  WEBMD_ONE: 'webmd-one',
}
